import { csx } from '@vtex/admin-ui'

const styles = {
  content: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-8',
  }),
}

export default styles
